
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'productType/save',
        method: 'post',
        data
    })
}

export function getSingle(data) {
    return request({
        url: 'productType/getSingle',
        method: 'post',
        data
    })
}

export function getPageList(data) {
    return request({
        url: 'productType/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'productType/delete',
        method: 'post',
        data
    })
}

export function getAll(data) {
    return request({
        url: 'productType/getAll',
        method: 'post',
        data
    })
}